import {ApplicationConfig, provideZoneChangeDetection, isDevMode} from '@angular/core';
import {provideRouter} from '@angular/router';
import Aura from '@primeuix/themes/aura';
import {routes} from './routes';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {providePrimeNG} from 'primeng/config';
import {definePreset} from '@primeuix/themes';
import {environment} from '../environments/environment';
import {MessageService} from 'primeng/api';
import {TranslocoHttpLoader} from './transloco-loader';
import {provideTransloco} from '@jsverse/transloco';

import dayjs from 'dayjs/esm';
import 'dayjs/esm/locale/he'
import localeData from 'dayjs/esm/plugin/localeData'
import {provideTranslocoPreloadLangs} from '@jsverse/transloco-preload-langs';
import {provideApi} from './api/provide-api';
import {authInterceptor} from './auth.interceptor';
dayjs.extend(localeData)

const MyPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}'
    }
  }
});

let currentLang = localStorage.getItem('lang');
if (currentLang && !/^[a-z]{2}_[a-z]{2}$/.test(currentLang)) {
  localStorage.removeItem('lang');
  currentLang = null;
}
const lang = currentLang || 'en_us';
dayjs.locale('en');

export const config: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([authInterceptor])
    ),
    provideApi({
      basePath: environment.api,
      credentials: {
        BearerAuth: () => {
          const token = localStorage.getItem('bisi-token');
          return token ? `Bearer ${token}` : undefined;
        }
      }
    }),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: MyPreset,
        options: {darkModeSelector: '.app-dark'},
      }
    }),
    MessageService,
    provideTransloco({
      config: {
        availableLangs: ['en_us', 'he_il'],
        defaultLang: lang,
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        fallbackLang: 'en_us',
        prodMode: !isDevMode(),
        missingHandler: {
          allowEmpty: true,
          logMissingKey: isDevMode(),
          useFallbackTranslation: true
        }
      },
      loader: TranslocoHttpLoader
    }),
    provideTranslocoPreloadLangs(['en_us', 'he_il'])
  ]
};
